import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconTrashcanSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.348 3a1 1 0 0 0-.988.845l-.323 2.053H4v2h1.558v12.1a1 1 0 0 0 1 1h10.89a1 1 0 0 0 1-1v-12.1h1.554v-2H15.97l-.322-2.053A1 1 0 0 0 14.659 3H9.348Zm5.694 4.898a.999.999 0 0 0 .142 0h1.264v11.1h-8.89v-11.1h1.264a1 1 0 0 0 .142 0h6.078Zm-1.098-2L13.804 5h-3.601l-.141.898h3.882Zm-2.496 4.255v7.098h-2v-7.098h2Zm3.108 1v-1h-2v7.098h2v-6.098Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconTrashcanSharp);
export default Memo;
